import EmailSubscribeForm from './EmailSubscribeForm';

export default EmailSubscribeForm;
